module.exports = __webpack_public_path__ + "static/media/blue.8588ad79.svg";